import React, { memo } from "react";

import SvgIcon from "@mui/material/SvgIcon";

export const SortDescIcon = memo((props) => {
  return (
    <SvgIcon viewBox="0 0 16 16" {...props}>
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <path d="M0 0H16V16H0V0Z" fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask0)">
        <path
          d="M14.6034 2H5V4.39661H14.6034V2ZM16 6.80169H7.11096V9.19831H16V6.80169ZM13.4008 11.5949H5V14H13.4008V11.5949Z"
          fill={props.fill ? props.fill : "white"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.09998 7C2.3209 7 2.49998 6.82091 2.49998 6.6V3.4C2.49998 3.17909 2.67907 3 2.89998 3H3.09998C3.3209 3 3.49998 3.17909 3.49998 3.4V6.6C3.49998 6.82091 3.67907 7 3.89998 7H5.19392C5.50184 7 5.69429 7.33333 5.54033 7.6L3.34639 11.4C3.19243 11.6667 2.80753 11.6667 2.65357 11.4L0.459643 7.6C0.305683 7.33333 0.498133 7 0.806053 7H2.09998Z"
          fill={props.fill ? props.fill : "white"}
        />
      </g>
    </SvgIcon>
  );
});
